import type { FlotiqStore, FlotiqStoreApiItem } from "@jti/fe-common";

export const getConvertedAddress = (item: Partial<FlotiqStore>, isAsianAddressFormatEnabled: boolean = false) => {
  const { State, Street, ZipCode, City } = item;
  const addressParts = isAsianAddressFormatEnabled ? [ZipCode, City, State, Street] : [Street, City, ZipCode];

  return addressParts.filter(Boolean).join(", ");
};

export const getTransformedMarkers = (items: FlotiqStoreApiItem[], isAsianAddressFormatEnabled: boolean = false) =>
  items.map((marker: FlotiqStoreApiItem) => {
    const address = getConvertedAddress(marker.item, isAsianAddressFormatEnabled);

    return {
      ...marker.item,
      address,
    };
  });
